import {
  compose,
  groupWith,
  has,
  map,
  filter,
  pipe,
  path,
  strictUniq,
  lensPath
} from "./functional.js";

const pathToGroup = ["metadata", "group"];
export const pathGroup = path(pathToGroup);
export const lensGroup = lensPath(["metadata", "group"]);

const areOfOneQuestion = (a, b) => {
  if (a.isfor === undefined && b.isfor === undefined) return false;
  return a.isfor === b.id || b.isfor === a.id;
};

export const groupInner = groupWith(areOfOneQuestion);

const InfinityIfMinus1 = num => (num + 1 || Infinity) - 1;
const indexOfOrInfinity = (sub, s) => InfinityIfMinus1(s.indexOf(sub));
export const baseGroup = s => s.substr(0, indexOfOrInfinity(".", s));
export const tailGroup = s => s.substr(indexOfOrInfinity(".", s) + 1);

const belongTogether = (a, b) =>
  areOfOneQuestion(a, b) ||
  (pathGroup(a) &&
    pathGroup(b) &&
    baseGroup(pathGroup(a)) === baseGroup(pathGroup(b)));

export const groupOuter = groupWith(belongTogether);

export const groupClasses = pipe(
  map(path[("metadata", "groupClasses")]),
  filter(Boolean),
  strictUniq
);

export const doGrouping = path(["arbitrary", "core", "form-group", "on"]);

const enhancePair = config => group => {
  if (group.length < 2) return group;

  // Identify roles regardless of array order
  const input = group.find(c => !c.isfor) || group[0];
  const label = group.find(c => c.isfor) || group[1];

  if (has("notnull", input)) label.isForNotNull = input.notnull;
  if (has("readonly", input)) label.readonly = input.readonly;
  label.dynamic = input.dynamic = /^datades:/.test(input.datatype);
  label.metadata = { ...input.metadata, ...label.metadata };
  // A11y & Meta
  input.meta = { ...input.meta, label: (label.value || "").trim() };
  input.aria = { ...input.aria, required: input.notnull };
  if (
    ["radio", "checkmultilist", "listbox", "multilist"].includes(
      input.controltype
    )
  ) {
    if (config.a11y.optionfieldsets) {
      label.controltype = "legend";
      label.className = "bb-label";
    } else {
      input.aria.labelledby = label.id;
    }
  } else if (input.controltype === "grid") {
    if (config.a11y.captions) {
      label.controltype = "caption";
      input.caption = label;
    } else {
      input.aria.labelledby = label.id;
    }
  } else {
    label.isFor = input.id;
  }
  return input.controltype === "checkbox" ? [input, label] : [label, input];
};

export const sortAndTransformControls = (
  controls,
  config = { a11y: { optionfieldsets: true, captions: true } }
) => compose(arr => arr.flatMap(enhancePair(config)), groupInner)(controls);
